// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialEditor-cls1_B9T","cls2":"SocialEditor-cls2_n7q SocialEditor-cls1_B9T"};